/* eslint-disable @typescript-eslint/default-param-last */
import {
  GET_LEDGER_DETAILS_FAILURE,
  GET_LEDGER_DETAILS_REQUEST,
  GET_LEDGER_DETAILS_SUCCESS,
} from '../constants/ActionTypes';
import initialState from '../store/initialState';
import { ILedgerDetailsActionType } from '../types/ledgerDetails.types';

const ledgerDetailsReducer = (
  state = initialState.ledgerDetails,
  action: ILedgerDetailsActionType
) => {
  switch (action.type) {
    case GET_LEDGER_DETAILS_REQUEST:
      return {
        ...state,
        leadgerLoading: true,
        ledgerDetailsError: null,
      };
    case GET_LEDGER_DETAILS_SUCCESS:
      return {
        ...state,
        leadgerLoading: false,
        ledgerDetails: action.payload.ledgerDetails,
        ledgerDetailsError: null,
      };
    case GET_LEDGER_DETAILS_FAILURE:
      return {
        ...state,
        leadgerLoading: false,
        ledgerDetailsError: action.payload.error,
      };
    default:
      return state;
  }
};

export default ledgerDetailsReducer;
